import { lazy } from 'react';

// ----------------------------------------------------------------------

const ReportsPage = lazy(() => import('../pages/Reports.page'));
const Customer = lazy(() => import('../pages/customer/Customer'));
const ServicesAndOrders = lazy(() => import('../pages/services-and-orders/ServicesAndOrders'));
const BranchesAndEmployees = lazy(() => import('../pages/branches-and-employees/BranchesAndEmployees'));
const Marketing = lazy(() => import('../pages/marketing/Marketing'));

// ----------------------------------------------------------------------

const ReportsRoutes = [
    {
        path: '/reports',
        element: <ReportsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/customer',
        element: <Customer />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/services-and-orders',
        element: <ServicesAndOrders />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/branches-and-employees',
        element: <BranchesAndEmployees />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/reports/marketing',
        element: <Marketing />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ReportsRoutes };
